
import React, { Component } from 'react';
import {connect} from 'react-redux';
import { Form, Field} from 'react-final-form';
import { CardFormHorizontalThird } from '../../widgets/Cards';
import { editPainExamination, newPainExamination, fetchPainExaminations } from '../../../actions';

class PainExamination extends Component {

    constructor(props) {
        super(props);
        this.state = {
            current_entry : null
        };
    };

    componentDidMount() {
        this.props.fetchPainExaminations(this.props.patient._id);
    }

    componentDidUpdate(prevProps) {
        if (this.props.patient._id !== prevProps.patient._id) {
                this.props.fetchPainExaminations(this.props.patient._id)
        }    
    }

    formButton() {
        var permit = this.props.selectedPermission.permission[0].pain;
        if (permit === "View only") {
            return "inaction";
        } else { 
            return "action";
        }  
    }
    
    PainExaminationForm() { 
        const all_contents = this.props.content;
        const last_entry = all_contents[(all_contents.length)-1];
        const content = last_entry;

        const handleSubmit = (formValues) => {
            const form = formValues;

        // Change Actions below
            this.props.newPainExamination(form);
        }

        const required = value =>(value ? undefined : 'Required');

// SECTION A
        return (
            <Form
                onSubmit = {handleSubmit}
                initialValues = {content}
                render = {({handleSubmit, pristine, form, values, submitting}) => {
                    return (
                        <form onSubmit={handleSubmit}>
                            <div className='header'>Pain Examination</div>

                            <div className='form-3-columns'>
                                <div>
                                    <Field name="date" component='input' label="Date" validate={required}>
                                        {({input, meta}) => (
                                                <div className={meta.active ? 'active':''}>
                                                    <label>Date</label>
                                                    <input size='30' {...input} type='date' />
                                                    {meta.error && meta.touched && <span className={'err'}>{meta.error}</span>}
                                                </div>
                                        )} 
                                    </Field>
                                    <Field name='posture' component='input' validate={required} placeholder='Posture'>
                                        {({input, meta, placeholder}) => (
                                            <div className={meta.active ? 'active':''}>
                                                <label>Posture</label>
                                                <textarea cols="80" rows='2' {...input} placeholder={placeholder} />
                                                {meta.error && meta.touched && <span className={'err'}>{meta.error}</span>}
                                            </div>
                                        )} 
                                    </Field>
                                    <Field name='gait' component='input' validate={required} placeholder='Gait'>
                                        {({input, meta, placeholder}) => (
                                            <div className={meta.active ? 'active':''}>
                                                <label>Gait</label>
                                                <textarea cols="80" rows='2' {...input} placeholder={placeholder} />
                                                {meta.error && meta.touched && <span className={'err'}>{meta.error}</span>}
                                            </div>
                                        )} 
                                    </Field>
                                    <Field name='mse' component='input' validate={required} placeholder='Mental State examination'>
                                        {({input, meta, placeholder}) => (
                                            <div className={meta.active ? 'active':''}>
                                                <label>Mental State Examination</label>
                                                <textarea cols="80" rows='8' {...input} placeholder={placeholder} />
                                                {meta.error && meta.touched && <span className={'err'}>{meta.error}</span>}
                                            </div>
                                        )} 
                                    </Field>
                                    </div>
                                    <div>
                                    <Field name='motor' component='input' validate={required} placeholder='motor examination of spine, upper/lower extremities'>
                                        {({input, meta, placeholder}) => (
                                            <div className={meta.active ? 'active':''}>
                                                <label>Motor Examination</label>
                                                <textarea cols="80" rows='4' {...input} placeholder={placeholder} />
                                                {meta.error && meta.touched && <span className={'err'}>{meta.error}</span>}
                                            </div>
                                        )} 
                                    </Field>
                                    <Field name='sensory' component='input' validate={required} placeholder='Sensory examination of spine, upper/lower extremities'>
                                        {({input, meta, placeholder}) => (
                                            <div className={meta.active ? 'active':''}>
                                                <label>Sensory Examination</label>
                                                <textarea cols="80" rows='4' {...input} placeholder={placeholder} />
                                                {meta.error && meta.touched && <span className={'err'}>{meta.error}</span>}
                                            </div>
                                        )} 
                                    </Field>
                                    <Field name='reflex' component='input' validate={required} placeholder='Reflexes'>
                                        {({input, meta, placeholder}) => (
                                            <div className={meta.active ? 'active':''}>
                                                <label>Reflexes</label>
                                                <textarea cols="80" rows='4' {...input} placeholder={placeholder} />
                                                {meta.error && meta.touched && <span className={'err'}>{meta.error}</span>}
                                            </div>
                                        )} 
                                    </Field>
                                    </div>
                                    <div>
                                    <Field name='cranial' component='input' validate={required} placeholder='Cranial nerves examination'>
                                        {({input, meta, placeholder}) => (
                                            <div className={meta.active ? 'active':''}>
                                                <label>Cranial Nerves Examination</label>
                                                <textarea cols="80" rows='7' {...input} placeholder={placeholder} />
                                                {meta.error && meta.touched && <span className={'err'}>{meta.error}</span>}
                                            </div>
                                        )} 
                                    </Field>
                                    <Field name='test' component='input' validate={required} placeholder='Tests'>
                                        {({input, meta, placeholder}) => (
                                            <div className={meta.active ? 'active':''}>
                                                <label>Tests</label>
                                                <textarea cols="80" rows='4' {...input} placeholder={placeholder} />
                                                {meta.error && meta.touched && <span className={'err'}>{meta.error}</span>}
                                            </div>
                                        )} 
                                    </Field>
                                    <Field name='tools' component='input' validate={required} placeholder='Tools eg. DN4 Questionnaire, K-10, etc. '>
                                        {({input, meta, placeholder}) => (
                                            <div className={meta.active ? 'active':''}>
                                                <label>Tools</label>
                                                <textarea cols="80" rows='4' {...input} placeholder={placeholder} />
                                                {meta.error && meta.touched && <span className={'err'}>{meta.error}</span>}
                                            </div>
                                        )} 
                                    </Field>

                                
                                </div>
                            </div>

                            <div className={this.formButton()}>
                                <button type='submit' disabled={submitting || pristine} className='btnew'>Submit</button>
                                <button type='button' onClick={form.reset} disabled={submitting || pristine } className='btdel'>Reset</button>
                                <button onClick={() => this.setState({showModal: false, record: null})} className='btdel'>Cancel</button>
                            </div>
                        </form>
                    )
                }}
            />
        )
    }

    render() {
        return (
            <CardFormHorizontalThird content={this.PainExaminationForm()}>
            </CardFormHorizontalThird>
        )
    }
}


const mapStateToProps = (state) => {
    return { 
             patient : state.selectedPatient,
             content : Object.values(state.pain_examinations),
             userId : state.auth.userId,
             selectedPermission : state.selectedPermission,
            };
}

export default connect(mapStateToProps,{editPainExamination, newPainExamination, fetchPainExaminations})(PainExamination);
